module.exports = __webpack_public_path__ + "img/ie.636f016d.svg";